const doc = [({"da":({"js":({"admin":({"messages":({"create_modal":({"the_message_was_created":"Beskeden blev oprettet"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;